import PropTypes from 'prop-types'
import { idPropType } from '../common/id-prop-type'
import { iso8601PropType } from '../common/iso-8601-prop-type'
import { objectTextMessageDirectionPropType } from './object-text-message-direction-prop-type'
import { objectTextMessageStatusPropType } from './object-text-message-status-prop-type'

/**
 * This is the ObjectTextMessage type definition for the REST model.
 *
 * @typedef {Object} ObjectTextMessage
 * @property {Id} messageId - The ID of the object text message
 * @property {Id} objectId - The ID of the object the text message was sent to or received from
 * @property {string} [messageText] - The text of the object text message
 * @property {ISO8601} [lastModified] - Latest time of the 3 times (messageTime, ackTime and reciveTime)
 * @property {ObjectTextMessageDirection} [direction] - The send direction of the message
 * @property {ObjectTextMessageStatus} [messageStatus] - Information about the status of a text message
 * @property {ISO8601} [messageTime] - Time when the message has been sent to an object or received by Webfleet
 * @property {Id} [userId] - ID of the user who sent the message to an object
 */
export const objectTextMessagePropType = PropTypes.shape({
    direction: objectTextMessageDirectionPropType,
    lastModified: iso8601PropType,
    messageId: idPropType.isRequired,
    messageStatus: objectTextMessageStatusPropType,
    messageText: PropTypes.string,
    messageTime: iso8601PropType,
    objectId: idPropType.isRequired,
    userId: idPropType
})
